module.exports = __webpack_public_path__ + "6162d93217ff6751a2b86992ad7d2e7f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-side-burn.png
// module id = 2699
// module chunks = 0